<template>
  <svg
    width="9"
    height="8"
    viewBox="0 0 9 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1235_3265)">
      <path
        d="M9 3.98982L0.628246 4.06446"
        stroke="#0A0E34"
        stroke-miterlimit="10"
      />
      <path
        d="M4.41211 8C4.41211 4.31552 0.036297 4.10517 0.036297 4.10517C0.036297 4.10517 4.22948 3.64377 4.22948 -7.98301e-09"
        stroke="#0A0E34"
        stroke-miterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_1235_3265">
        <rect
          width="8"
          height="9"
          fill="white"
          transform="translate(9) rotate(90)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

</style>
